import { Carousel, Slide } from '@jambonn/vue-concise-carousel';
import '@jambonn/vue-concise-carousel/lib/vue-concise-carousel.css';
import LiteYouTubeEmbed from 'vue-lite-youtube-embed';
import 'vue-lite-youtube-embed/style.css';
import DynamicForm from 'components/forms/DynamicForm.vue';
import ExtendableContent from 'components/ExtendableContent.vue';

export default {
  install(app) {
    app.component('carousel', Carousel);
    app.component('slide', Slide);
    app.component('youtube', LiteYouTubeEmbed);
    app.component('dynamic-form', DynamicForm);
    app.component('extendable-content', ExtendableContent);

    // eslint-disable-next-line max-len
    const youtubeRegexp = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig;

    app.config.globalProperties.getYoutubeIdFromUrl = (url) => {
      let id = url.replace(youtubeRegexp, '$1');

      if (id.includes(';')) {
        const pieces = id.split(';');

        if (pieces[1].includes('%')) {
          const uriComponent = decodeURIComponent(pieces[1]);
          id = (`http://youtube.com${uriComponent}`).replace(youtubeRegexp, '$1');
        } else {
          // eslint-disable-next-line prefer-destructuring
          id = pieces[0];
        }
      } else if (id.includes('#')) {
        // eslint-disable-next-line prefer-destructuring
        id = id.split('#')[0];
      }

      return id;
    };
  }
};
